import { useSearchQuery } from 'src/hooks/useSearchQuery';
import { ESubscriptionReason } from 'src/services/analytics/events';
import { useAccountSelect } from 'src/hooks/useAccount';


export interface ISearchQueryParams extends IUseRouterPaywallSubscriptionOpen {
  modal?: string,
}
export interface IUseRouterPaywallSubscriptionOpen {
  dialogId?: string;
  reason?: `${ESubscriptionReason}`,
  botName?: string,
  message_id?: string;
  redirectModal?: string;
  redirectPage?: string;
  priceId?: string;
  already?: string;
  priority_category?: string;
}
export const useRouterPaywallSubscription = ()=> {
  const { query, setQuery, removeQuery } = useSearchQuery<ISearchQueryParams>();
  const isAnonymous = useAccountSelect.isAnonymous();

  const open = (params:IUseRouterPaywallSubscriptionOpen)=> {
    // Если пользователь анонимный - редиректим на форму регистрации
    if (isAnonymous) {
      setQuery({
        modal: 'auth',
        redirectModal: 'paywall-subscription',
        ...params
      });
      return;
    }

    setQuery({
      modal:'paywall-subscription',
      ...params
    })
  }
   const close = () => {
     removeQuery([
       'modal',
       'dialogId',
       'message_id',
       'reason',
       'botName',
       'redirectModal',
       'priceId',
       'already',
       'priority_category',
     ]);
   };

   return {
    query,
    setQuery,
    removeQuery,
    open,
    close
   }
}